<template>
  <van-tabbar v-model="active" active-color="red" route class="custom-tabbar">
    <van-tabbar-item icon="home-o" to="/" class="custom-tabbar-item"
      >春信精油</van-tabbar-item
    >
    <van-tabbar-item icon="music-o" to="/portfolio" class="custom-tabbar-item"
      >推荐</van-tabbar-item
    >
    <van-tabbar-item v-if="false" icon="hot-o" to="/service" class="custom-tabbar-item"
      >套餐</van-tabbar-item
    >
    <van-tabbar-item v-if="false" icon="medal" to="/tech" class="custom-tabbar-item"
      >健康师</van-tabbar-item
    >
    <van-tabbar-item icon="chat-o" to="/message-center" :badge="unreadCount>0?unreadCount:''" class="custom-tabbar-item"
      >消息</van-tabbar-item
    >
    <van-tabbar-item icon="user" to="/my" class="custom-tabbar-item"
      >我的</van-tabbar-item
    >
  </van-tabbar>
</template>

<script setup>
import { ref, watch, onMounted, onActivated } from "vue";
import { useUserStore } from "@/stores/user";
import { useRoute } from "vue-router";
import { countUnRead } from "@/api/message";

const route = useRoute();
const userStore = useUserStore();
const active = ref(route.path); // 根据当前路由高亮对应菜单项

const unreadCount = ref(0); // 消息未读数量

// 获取未读消息数
const fetchUnreadCount = async () => {
  if (!userStore.token) {
    return;
  }
  try {
    // 调用接口获取未读数量
    const count = await countUnRead();
    unreadCount.value = count;
  } catch (error) {
    console.error('获取消息未读数量失败：', error);
    unreadCount.value = 0; // 异常时置0，避免角标显示错误
  }
};

// 组件激活时重新加载（解决从其他页面返回时数据不刷新的问题）
onActivated(() => {
  fetchUnreadCount();
});

// 监听路由变化，确保tab高亮正确
watch(
  () => route.path,
  (oldPath, newPath) => {
    active.value = newPath;
    // 切换到消息页时，可选择清空未读数量（需结合接口标记已读）
    if (newPath != oldPath) {
      fetchUnreadCount();
    }
  }
);
</script>

<style scoped>
/* 调整整个TabBar的高度 */
.custom-tabbar {
  height: 70px;
  /* 默认约50px，这里增加到60px */
  padding-bottom: calc(10px + var(--safe-area-inset-bottom, 0px));
  /* 适配移动端底部安全区域 */
  box-sizing: content-box;
}

/* 调整TabBarItem的样式使其居中 */
.custom-tabbar-item {
  flex-direction: column;
  justify-content: center;
  padding-top: 6px;
  /* 调整顶部内边距使内容居中 */
}

/* 可以根据需要调整图标和文字大小 */
:deep(.van-tabbar-item__icon) {
  font-size: 22px;
  /* 增大图标 */
}

:deep(.van-tabbar-item__text) {
  font-size: 14px;
  /* 调整文字大小 */
  margin-top: 2px;
  /* 调整文字与图标间距 */
}
</style>
